import { IApplicationState } from '../../../types/redux';

export function selectNewbuildingPromosTitle(state: IApplicationState): string {
  return state.promosPage.newbuildingPromosV2?.title || '';
}
